import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getAllNotifications } from 'src/axious/notifications'
import { Header } from 'src/components'
import { useChangeBackground } from 'src/hooks/useChangeBackground'

import styles from './Notifications.module.scss'
import type { NotificationType } from './Notifications.types'
import { NoNotifications, Notification } from './components'

const Notifications = () => {
  const [notificationsData, setNotificationsData] = useState<NotificationType[]>([])
  useChangeBackground(styles['white-background'])
  const notificationsLength = localStorage.getItem('notifications_length')
  const { t } = useTranslation()

  React.useEffect(() => {
    getAllNotifications()
      .then((data: any) => {
        setNotificationsData(data)

        if (data.length > Number(notificationsLength)) {
          localStorage.setItem('notifications_length', String(data.length))
        }
      })
      .catch((err: any) => console.log(err))
  }, [])

  return (
    <>
      <Header variant='settings' color='black' setting={t('notifications_page.title')} path='..' />

      <main className={`${styles.wrapper} ${notificationsData && styles.notifications}`}>
        {!notificationsData ? (
          <NoNotifications />
        ) : (
          <div className={styles.notification_list}>
            {notificationsData.map((item: any) => (
              <Notification {...item} key={item.id} />
            ))}
          </div>
        )}
      </main>
    </>
  )
}

export default Notifications
